var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.770304 6.66667H4.7703C5.13697 6.66667 5.43697 6.36667 5.43697 6V0.666667C5.43697 0.3 5.13697 0 4.7703 0H0.770304C0.403638 0 0.103638 0.3 0.103638 0.666667V6C0.103638 6.36667 0.403638 6.66667 0.770304 6.66667ZM0.770304 12H4.7703C5.13697 12 5.43697 11.7 5.43697 11.3333V8.66667C5.43697 8.3 5.13697 8 4.7703 8H0.770304C0.403638 8 0.103638 8.3 0.103638 8.66667V11.3333C0.103638 11.7 0.403638 12 0.770304 12ZM7.43697 12H11.437C11.8036 12 12.1036 11.7 12.1036 11.3333V6C12.1036 5.63333 11.8036 5.33333 11.437 5.33333H7.43697C7.0703 5.33333 6.7703 5.63333 6.7703 6V11.3333C6.7703 11.7 7.0703 12 7.43697 12ZM6.7703 0.666667V3.33333C6.7703 3.7 7.0703 4 7.43697 4H11.437C11.8036 4 12.1036 3.7 12.1036 3.33333V0.666667C12.1036 0.3 11.8036 0 11.437 0H7.43697C7.0703 0 6.7703 0.3 6.7703 0.666667Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardicon);
export default __webpack_public_path__ + "static/media/dashboardicon.56d3919ef69aeadbc7ab32b4f25a53c3.svg";
export { ForwardRef as ReactComponent };